import { render } from "./TermsComponent.vue?vue&type=template&id=e3c95a64&scoped=true"
const script = {}

import "./TermsComponent.vue?vue&type=style&index=0&id=e3c95a64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c95a64"]])

export default __exports__